// extracted by mini-css-extract-plugin
export default {"btn":"VendorStats_btn__ucgUJ"};